import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { St4w } from '@classes/st4w';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class St4wService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/st4w';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }
  
  getSt4ws(): Observable<Array<St4w>> {
    return this.http.get<Array<St4w>>(this.basePath);
  }
}
